import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

import AppRoutes from './app/AppRoutes';
import { AuthProvider } from './hooks/useAuth';
import { SelectedClientProvider } from './hooks/useSelectedClient';
import ErrorPage from './features/errors/ErrorPage';

const AUTH_KEYS = [
  'igtoken', 'NCToken', 'ratetoken', 'tenantId', 'RoleId',
  'AvatarName', 'st', 'SocialLogin', 'NCAgencyId', 'NowcertsAgentId',
  'firstName', 'lastName', 'workEmail', 'userName',
];

function handle401() {
  AUTH_KEYS.forEach(k => localStorage.removeItem(k));
  window.location.href = '/';
}

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) handle401();
    return Promise.reject(err);
  }
);

const _fetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  const res = await _fetch(...args);
  if (res.status === 401) handle401();
  return res;
};

class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return <ErrorPage onReset={this.handleReset} />;
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <AppErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <SelectedClientProvider>
            <AppRoutes />
          </SelectedClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}
